
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum SettlementStatus {
	Unconfirmed = 0,
	Sent = 1,
	Completed = 2,
	Cancelled = 3,
	Breach = 4
}
export namespace SettlementStatus {
	export function getKeys(): Map<SettlementStatus, string> {
		return new Map([[0, 'Unconfirmed'], [1, 'Sent'], [2, 'Completed'], [3, 'Cancelled'], [4, 'Breach']]);
	}
}
